import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

const initialState = {
  testValues: {},
  loading: true,
};

const googleOptimizeSlice = createSlice({
  name: "testValues",
  initialState,
  reducers: {
    setLoading(state, { payload }) {
      state.loading = payload;
    },
    setTestValue(state, { payload }) {
      state.testValues = payload;
    },
  },
});

export const { actions } = googleOptimizeSlice;
export default googleOptimizeSlice.reducer;

export const useGoogleOptimizeActions = () => {
  const dispatch = useDispatch();

  const setLoading = (loading) => {
    dispatch(googleOptimizeSlice.actions.setLoading(loading));
  };
  const updateTestValues = (tests) => {
    dispatch(googleOptimizeSlice.actions.setTestValue(tests));
  };

  return {
    setLoading,
    updateTestValues,
  };
};
